import { useAppMutation } from './useAppMutation';

interface EnrolStudentsPayload {
  courseIds: string[];
  employeeIds: string[];
}

export const useEnrolStudents = () => {
  return useAppMutation<unknown, unknown, EnrolStudentsPayload>(
    'post',
    '/TrainingManager/courses/enrol'
  );
};
